"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import type { ExamData } from "@/types/exam-detail";

/**
 * Accordion kurikulum — daun detail ujian MILIK zona landing (duplikasi penuh per-zona
 * 2026-09-26; pasangan antar-zona: `(user)/ujianku/[slug]/_components/exam-detail-sections.tsx`). Eks satu file shared
 * `exam-detail-interactive` di kolam global.
 */
/** Accordion kurikulum — satu seksi terbuka; pertama terbuka by default. */
export function ExamDetailSections({
  sections,
  durationMode,
  passingGradeMode,
}: {
  sections: ExamData["sections"];
  durationMode: string;
  passingGradeMode: string;
}) {
  const [expandedSection, setExpandedSection] = useState<string | null>(
    sections[0]?.id || null,
  );

  return (
    <div className="border-border bg-card divide-border mt-3 overflow-hidden rounded-2xl border">
      {sections.map((section, idx) => {
        const isOpen = expandedSection === section.id;
        return (
          <div key={section.id} className="divide-border divide-y">
            <Button
              type="button"
              variant="ghost"
              onClick={() => setExpandedSection(isOpen ? null : section.id)}
              className="hover:bg-muted/60 h-auto w-full justify-start gap-3 rounded-none px-4 py-3.5 text-left sm:px-5"
            >
              <span className="text-foreground/30 w-5 shrink-0 text-center text-xs font-black">
                {idx + 1}
              </span>
              <span className="text-foreground min-w-0 flex-1 truncate text-sm font-bold">
                {section.title}
              </span>
              <span className="text-foreground/45 hidden text-xs font-medium sm:inline">
                {section.questionCount} soal
                {durationMode === "per_section" && <> · {section.durationMinutes} mnt</>}
              </span>
              <ChevronDown
                size={16}
                className={`text-foreground/30 shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`}
              />
            </Button>
            <div
              className={`grid overflow-hidden transition-[grid-template-rows,opacity] duration-200 ease-out motion-reduce:transition-none ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="text-foreground/60 px-4 py-3 pl-12 text-xs leading-relaxed sm:px-5">
                  {section.description || "Tidak ada deskripsi"}
                  <span className="text-foreground/45 mt-1 block sm:hidden">
                    {section.questionCount} soal
                    {durationMode === "per_section" && (
                      <> · {section.durationMinutes} mnt</>
                    )}
                  </span>
                  {passingGradeMode === "per_section" && (
                    <span className="text-foreground/45 mt-1 hidden sm:block">
                      Passing grade seksi: {section.passingGrade}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
